module.exports = __webpack_public_path__ + "static/img/10005.6cd81e1b.png";